/** Lodge primary toolbar/sidenav background from VITE_HEADER_COLOR. */
export function getToolbarBg() {
    // @ts-ignore - Vite injects `import.meta.env` at build time
    const headerColor = import.meta.env.VITE_HEADER_COLOR
    return headerColor ? `#${headerColor}` : "#0f6170"
}
